import Swiper from 'swiper/bundle';

class PetLinkItems {
  constructor() {
    this.wrapper = document.querySelector("[data-role='pet-link-items']");

    if (!this.wrapper) return;

    this.swiperElm = this.wrapper.querySelector("[data-role='pet-link-swiper']");
    this.swiperNext = this.wrapper.querySelector("[data-role='pet-link-swiper-next']");
    this.swiperPrev = this.wrapper.querySelector("[data-role='pet-link-swiper-prev']");

    if (!this.swiperElm || !this.swiperNext || !this.swiperPrev) return;

    this.swiper = new Swiper(this.swiperElm, {
      slidesPerView: 3,
      spaceBetween: 22,
      loop: true,
      // centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev,
      },
    });
  }
}

export default PetLinkItems;
